import styled from 'styled-components';

export const StyledBodyWrapper = styled.div`
  max-height: 75vh;
  margin-right: 10px;
  padding: 30px;
  overflow: auto;

  &::-webkit-scrollbar {
    width: 6px;
  }

  &::-webkit-scrollbar-track {
    background: #171C2810 0% 0% no-repeat padding-box;
    border-radius: 4px;
  }

  &::-webkit-scrollbar-thumb {
    background: #555BF0 0% 0% no-repeat padding-box;
    border-radius: 4px;
  }

  width: 100%;

  .limit-modal-title {
    font-size: 22px;
    font-weight: bold;
    text-align: center;
    color: ${({ theme }) => theme.colors.primaryDark};
    margin-bottom: 44px;
  }

  .inputs-container {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: 10px;

    .email-input {
      width: 280px;
    }

    .email-input > div {
      height: 40px;
      max-width: 280px;
    }
  }

  .update-btn-container {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 40px;
  }
`;
